
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import { EVENTS } from '@/author/constants';
import { LOCK_CONST } from '@/constants';
import Scorm from '@/mixins/Scorm';
import Bookmark from '@/models/Bookmark';
import { mixins } from 'vue-class-component';

const AppState = getModule(AppModule, store);

@Component
export default class BaseComponent extends mixins(Scorm) {

  created(){
    this.init();
  }

  get getSavedData(): any {
    return AppState.getSavedData;
  }

  get getCurrentSlide(): string {
    return AppState.currentSlide;
  }
  get getLockMode(): number {
    return AppState.getLockMode;
  }

  lockForward() {
    AppState.setLock(LOCK_CONST.FORWARD_LOCKED);
  }

  unlock() {
    AppState.setLock(LOCK_CONST.UNLOCKED);
  }

  lock() {
    AppState.setLock(LOCK_CONST.TOTALLY_LOCKED);
  }

  saveData(data: any) {
    const newBookmark: Bookmark = { ...this.getBookmark(), lastSlideState: data };
    this.setBookmark(newBookmark);
    AppState.saveData(data);
  }

  chooseAnswer(right: boolean) {
    AppState.chooseAnswer(right);
  }

  emitRefreshed() {
    this.emitEvent(EVENTS.REFRESHED);
  }

  emitCompleted() {
    this.emitEvent(EVENTS.COMPLETED);
  }

  emitEvent(eventName: string) {
    this.$parent.$emit(eventName);
  }

  focusOnSlideTitle(){
    setTimeout(() => {
        let slideTitle = document.getElementById('slideTitle');
        if(slideTitle) slideTitle.focus();
    }, 200);
  }
}
